import type { RichEditorPreset } from '../types';

interface PresetCardsProps {
    presets: RichEditorPreset[];
    onPick: (preset: RichEditorPreset) => void;
    onSkip: () => void;
}

/**
 * Empty-state preset picker shown at the top of the editor when there's
 * no content yet and at least one preset is available. Cards expose the
 * preset label + description; "Start blank" dismisses the picker without
 * loading anything.
 */
export function PresetCards({ presets, onPick, onSkip }: PresetCardsProps) {
    return (
        <div className="px-3 pt-3 pb-1">
            <div className="flex items-center justify-between mb-2">
                <div className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider">
                    Start from a preset
                </div>
                <button
                    type="button"
                    onClick={onSkip}
                    className="text-[11px] font-medium text-gray-500 hover:text-gray-800 transition-colors"
                >
                    Start blank →
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5">
                {presets.map((p) => (
                    <button
                        key={p.id}
                        type="button"
                        onClick={() => onPick(p)}
                        className="text-left rounded-lg border border-gray-200 bg-white p-3 hover:border-gray-400 hover:bg-gray-50 transition-colors"
                    >
                        <div className="text-sm font-semibold text-gray-800 mb-0.5">{p.label}</div>
                        {p.description && (
                            <div className="text-xs text-gray-500 leading-snug line-clamp-3">
                                {p.description}
                            </div>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}
